// extracted by mini-css-extract-plugin
export default {"position":"EditButton_position__vsdwc","pencilEditButton":"EditButton_pencilEditButton__9plJO"};